var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view'),_c('apollo-posts',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMainFeed),expression:"showMainFeed"}],staticClass:"grow overflow-hidden",attrs:{"type":_vm.feedType,"feed-type":"flat"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }